import tw from 'twin.macro';
import { atom, useAtomValue } from 'jotai';
import { FormProvider, useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@restworld/feature-authentication';
import { useEmployersService } from '@restworld/data-services';

import { selectedJobApplicationAtom } from '../../../../employer-job-listing.atoms';
import { CandidateNotesList } from './candidate-notes-list';
import { CandidateNotesForm } from './candidate-notes-form';

export type TFormValues = {
  note: string;
};
export const editModeAtom = atom(false);
export const editIdAtom = atom<number>(-1);

const CandidateNotesSection = () => {
  const methods = useForm<TFormValues>({ defaultValues: { note: '' } });
  useNoteQuery();
  return (
    <FormProvider {...methods}>
      <MainWrapper>
        <CandidateNotesList />
        <CandidateNotesForm />
      </MainWrapper>
    </FormProvider>
  );
};
export default CandidateNotesSection;

const MainWrapper = tw.div``;

export const useNoteQueryKey = () => {
  const jobApp = useAtomValue(selectedJobApplicationAtom);
  const notesQueryKey = ['notes', jobApp?.worker_id];
  return notesQueryKey;
};

const useNoteQuery = () => {
  const employerServices = useEmployersService();
  const jobApp = useAtomValue(selectedJobApplicationAtom);
  const queryKey = useNoteQueryKey();
  const userData = useAuth().user;

  useQuery({
    queryKey,
    enabled: !!jobApp?.worker_id,
    queryFn: async () =>
      (
        await employerServices.fetchNotes({
          entityCategory: 'employer_worker_job_positions',
          entityId: jobApp?.worker_id,
          organizationId: userData?.organization_id,
        })
      ).data,
  });
};
